<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime poslovne enote *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-select
          :items="premiseTypesWithNull"
          item-text="name"
          item-value="val"
          v-model="form.premise_type"
          label="Tip poslovnega prostora"
        ></v-select>
        <v-text-field
          v-model="form.business_premise_id"
          label="Oznaka poslovenga prostora *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.business_premise_id.required)"
        >
          <FormErrorsLine v-if="!$v.form.business_premise_id.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.address"
          label="Naslov"
        ></v-text-field>
        <v-text-field
          v-model="form.house_number"
          label="Hišna številka"
        ></v-text-field>
        <v-text-field
          v-model="form.house_number_addition"
          label="Dodatek k hišni številki"
        ></v-text-field>
        <v-text-field
          v-model="form.post_code"
          label="Poštna številka"
        ></v-text-field>
        <v-text-field
          v-model="form.city"
          label="Mesto"
        ></v-text-field>
        <v-text-field
          v-model="form.community"
          label="Naselje"
        ></v-text-field>
        <v-text-field
          v-model="form.cadastral_number"
          type="number"
          label="Katasterska številka"
        ></v-text-field>
        <v-text-field
          v-model="form.building_number"
          type="number"
          label="Številka stavbe"
        ></v-text-field>
        <v-text-field
          v-model="form.building_section_number"
          type="number"
          label="Številka dela stavbe"
        ></v-text-field>

        <br v-if="newBusinessUnit">
        <v-select
          v-if="newBusinessUnit"
          :items="sourceBusinessUnitsWithNull"
          item-text="name"
          item-value="val"
          v-model="form.source_business_unit"
          label="Kopiraj podatke od"
        ></v-select>

        <br>
        <v-text-field
          v-model="form.seller_tax_number"
          label="Izdajanje računov v imenu in za namen"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.seller_tax_number.isTaxNumber)"
        >
          <FormErrorsLine v-if="!$v.form.seller_tax_number.isTaxNumber" text="Davčna številka ni veljavna" />
        </FormErrors>

        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import { mapActions } from 'vuex'
import { isValidTaxNumber } from '@/utils/taxNumber'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    businessUnit: {
      default: () => {},
      type: Object
    },
    childCompanyId: {
      default: null,
      type: Number
    },
    premiseTypes: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      premiseTypesWithNull: [],
      sourceBusinessUnitsWithNull: [],
      form: {
        name: '',
        business_premise_id: '',
        premise_type: null,
        address: '',
        house_number: '',
        house_number_addition: '',
        post_code: '',
        city: '',
        community: '',
        cadastral_number: null,
        building_number: null,
        building_section_number: null,
        source_business_unit: null,
        seller_tax_number: null
      }
    }
  },
  computed: {
    newBusinessUnit () {
      return this.businessUnit ? Object.keys(this.businessUnit).length === 0 : true
    },
    createDefArtices () {
      return this.form.create_default_articles
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      business_premise_id: {
        required
      },
      seller_tax_number: {
        isTaxNumber: val => !val || isValidTaxNumber(val)
      }
    }
  },
  methods: {
    ...mapActions('clientsBusinessUnits', ['sourceBusinessUnits']),
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.form.validity_date = this.$moment().toISOString()
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {
    this.form = { ...this.form, ...this.businessUnit }
    this.premiseTypesWithNull.push({
      name: 'Brez tipa prostora',
      val: null
    })
    this.premiseTypes.forEach(type => {
      this.premiseTypesWithNull.push({
        name: `${type.id} - ${type.name}`,
        val: type.id
      })
    })
    if (this.newBusinessUnit) {
      this.sourceBusinessUnits({ childCompanyId: this.childCompanyId })
        .then(sourceBusinessUnits => {
          this.sourceBusinessUnitsWithNull.push({
            name: 'Ne kopiraj šifrantov',
            val: null
          })
          const sortedSourceBusinessUnits = sourceBusinessUnits.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
          sortedSourceBusinessUnits.forEach(unit => {
            this.sourceBusinessUnitsWithNull.push({
              name: `${unit.name}`,
              val: unit.id
            })
          })
        })
    }
  },
  watch: {
    createDefArtices (createArticles) {
      this.form.create_default_categories = createArticles
    }
  }
}
</script>
